import { useMemo } from 'react';
import { createTheme } from '@mui/material/styles';
import usePalette from './palette';
import useTypography from './typography';

const useThemeConfig = () => {
  const { palette, isDataLoaded } = usePalette();
  const typography = useTypography(palette);

  const theme = useMemo(() => {
    if (!isDataLoaded) {
      return createTheme();
    }

    const t = createTheme({
      palette,
      typography,
      components: {
        MuiDialogTitle: {
          styleOverrides: {
            root: {
              fontFamily: typography.fontFamily,
            },
          },
        },
        MuiDialogContent: {
          styleOverrides: {
            root: {
              fontFamily: typography.fontFamily,
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            containedPrimary: {
              backgroundColor: palette.primary.main,
              color: palette.text.colorText1,
              '&:hover': {
                backgroundColor: palette.primary.main,
                color: palette.text.colorText1,
                opacity: 0.9,
              },
            },
          },
        },
      },
    });

    // atajos
    t.primary = palette.primary.main;
    t.secondary = palette.secondary.main;
    t.tertiary = palette.tertiary.main;

    t.text1 = palette.text.colorText1;
    t.text2 = palette.text.colorText2;
    t.textGray = palette.text.textGray;
    t.darkGray = palette.text.darkGray;
    t.white = palette.text.textWhite;

    t.red = palette.extraColors.red;
    t.headerColor = palette.extraColors.headerColor;
    t.footerColor = palette.extraColors.footerColor;

    return t;
  }, [palette, typography, isDataLoaded]);

  return { theme, isDataLoaded };
};

export default useThemeConfig;
